import request from '@/utils/request'

export function getCharts() {
  return request({
    url: '/charts/availablecharts',
    method: 'post',
    // data: findRequest,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function getChartsSection(query) {
  return request({
    url: '/charts/getchartsection',
    method: 'post',
    data: query,
    timeout: 45000,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
